export default __webpack_public_path__ + "static/media/x.a9d4a1fc.svg";